var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.person)?_c('div',{staticClass:"flex space-between items-center justify-center mb-14",class:{
    'flex-col': _vm.failed,
  }},[_c('div',{staticClass:"w-24 h-24 md:w-36 md:h-36 cursor-pointer flex-0",class:{
      '!w-72 !h-72 mb-5': _vm.failed,
    },on:{"click":function($event){_vm.$router.push(
        _vm.localePath({
          name: 'professionalPage',
          params: {
            professionalSeoName: _vm.person.seoName,
          },
        })
      )}}},[_c('PersonPictureSet',{staticClass:"w-24 h-24 md:w-36 md:h-36 rounded-full",class:{
        '!w-72 !h-72': _vm.failed,
      },attrs:{"person":_vm.person}})],1),(_vm.failed)?[_c('p',{staticClass:"text-center mb-10"},[_c('NuxtLink',{staticClass:"font-black text-center",attrs:{"target":"_blank","to":_vm.localePath({
            name: 'professionalPage',
            params: {
              professionalSeoName: _vm.person.seoName,
            },
          })}},[_vm._v(" "+_vm._s(_vm.person.name)+" ")])],1),_c('div',{staticClass:"relative"},[_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"hidden md:block absolute top-[-176px] left-[-150px]",attrs:{"data-src":require("assets/img/curved-arrow.svg")}}),_c('JoszakiPill',{staticClass:"!font-black !rounded-lg text-lg md:!text-3xl !text-center mx-auto",attrs:{"type":"info"}},[_vm._v(" "+_vm._s(_vm.$t("professionalRating.headline.areYouSure"))+" ")])],1)]:[_c('p',{staticClass:"font-light flex-1 ml-2 text-2xl md:text-4xl"},[_vm._v(" "+_vm._s(_vm.$t("professionalRating.headline.ratePerson", { mateName: _vm.person.name, }))+" ")])]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }